// extracted by mini-css-extract-plugin
module.exports = {"desktop-menu":"desktop-menu___2rID0","desktopMenu":"desktop-menu___2rID0","item":"item___30pS9","item--isActive":"item--isActive___3Aj2d","itemIsActive":"item--isActive___3Aj2d"};